/* import __COLOCATED_TEMPLATE__ from './postings-list.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-postings-list';

class PostingsList extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }
}

export default PostingsList;
